/* eslint-disable import/prefer-default-export, prefer-template */
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) {
    return match[2];
  }
  return null;
}

export {
  getCookie,
};
